import React from 'react';

function Contact() {
  return (
    <section
      id="contact"
      className="bg-slate-900 text-white px-6 py-16 text-center scroll-mt-28"
    >
      <h2 className="text-3xl font-bold mb-4">Get in Touch</h2>
      <p className="text-lg mb-8">
        Interested in working together? Feel free to reach out for collaborations
        or just a friendly hello.
      </p>

      <div className="mb-6">
        <p className="text-xl font-semibold">Email me</p>
        <p className="text-lg text-blue-400 mt-2">
          <a href="mailto:ravi007nkl@gmail.com">ravi007nkl@gmail.com</a>
        </p>
        <p className="text-lg text-blue-400 mt-1">📞 +91 73971 45824</p>
      </div>

      <div className="flex justify-center gap-4">
        <a
          href="https://www.linkedin.com/in/ravi-krishnamoorthy-devops"
          target="_blank"
          rel="noopener noreferrer"
          className="border border-blue-500 text-blue-500 px-6 py-2 rounded hover:bg-blue-500 hover:text-white transition"
        >
          Connect on LinkedIn
        </a>
        <a
          href="/Ravi_DevOps.pdf"
          download
          className="border border-gray-500 text-white px-6 py-2 rounded hover:bg-gray-500 hover:text-white transition"
        >
          Download CV
        </a>
      </div>

      <footer className="mt-16 text-sm text-gray-400 flex justify-between px-6 md:px-24">
        <p>© 2025 Ravi. All rights reserved.</p>
        <div className="flex gap-4">
          <a href="#">Privacy Policy</a>
          <a href="#">Terms of Service</a>
        </div>
      </footer>
    </section>
  );
}

export default Contact;
